import { SliceCaseReducers } from '@reduxjs/toolkit'
import { AccountDetail, AccountDetailParams } from '@repo/accounts-types'
import {
  ApiResponse,
  createDownloadSlice,
  createOperationSlice,
  GenericOperationState,
} from '@repo/core'

const initialState: GenericOperationState<ApiResponse<AccountDetail> | null> = {
  payload: null,
  meta: { fetchState: 'initial' },
  error: false,
}

export interface AccountDetailRequestParams extends AccountDetailParams {
  currency?: string
  date?: string | null
  interventionType?: string
}

export const { actions: accountDetailDataActions, reducer: accountDetailDataReducer } =
  createOperationSlice<
    ApiResponse<AccountDetail> | null,
    SliceCaseReducers<GenericOperationState<ApiResponse<AccountDetail> | null>>,
    AccountDetailRequestParams
  >({
    name: '@accounts/detail/read/accountDetailData',
    initialState,
    reducers: {
      updateAlias: (state, action) => {
        if (!state.payload) return
        state.payload.data.header.alias = action.payload.alias
      },
    },
  })

export const { actions: accountDetailDownloadActions, reducer: accountDetailDownloadReducer } =
  createDownloadSlice<AccountDetailRequestParams>('@accounts/detail/read/accountDetailDownload')
